module.exports = __webpack_public_path__ + "static/media/combat(28).d1a04c16.PNG";